import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

// Note: we don't install clsx/tailwind-merge separately — implement inline
// If you want, run: npm i clsx tailwind-merge  (already battle-tested approach)

/** Merge Tailwind classes safely, resolving conflicts. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Format a full name */
export function fullName(firstName: string, lastName: string) {
  return `${firstName} ${lastName}`.trim()
}

/** Get initials from a name */
export function initials(firstName: string, lastName: string) {
  return `${firstName[0] ?? ''}${lastName[0] ?? ''}`.toUpperCase()
}

/** Format currency */
export function formatCurrency(amount: number, currency = 'USD') {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount)
}

/** Truncate text */
export function truncate(str: string, max: number) {
  return str.length > max ? str.slice(0, max - 1) + '…' : str
}

/** Slugify a string */
export function slugify(str: string) {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

/** Parse JSON safely */
export function safeJSON<T>(str: string | null | undefined, fallback: T): T {
  if (!str) return fallback
  try {
    return JSON.parse(str) as T
  } catch {
    return fallback
  }
}

/** Day of week labels */
export const DAY_LABELS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] as const

/** Appointment type display labels */
export const APPOINTMENT_TYPE_LABELS = {
  SESSION: 'Session',
  CONSULTATION: 'Consultation',
  FOLLOW_UP: 'Follow-up',
  GROUP: 'Group Session',
} as const
